import { render, staticRenderFns } from "./CommodityMarketingDiscuss.vue?vue&type=template&id=7d3a6cbd&scoped=true&"
import script from "./CommodityMarketingDiscuss.vue?vue&type=script&lang=js&"
export * from "./CommodityMarketingDiscuss.vue?vue&type=script&lang=js&"
import style0 from "./CommodityMarketingDiscuss.vue?vue&type=style&index=0&id=7d3a6cbd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3a6cbd",
  null
  
)

export default component.exports